"use client";

import { c as _c } from "react/compiler-runtime";
import ChatBubbleIcon from "@/components/common/icons/ChatBubbleIcon";
import WavesIcon from "@/components/common/icons/WavesIcon";
import { NEXTGEN_CHAIN_ID, NEXTGEN_CORE } from "@/components/nextGen/nextgen_contracts";
import { USER_PAGE_TAB_IDS } from "@/components/user/layout/userTabs.config";
import { GRADIENT_CONTRACT, MEMELAB_CONTRACT, MEMES_CONTRACT } from "@/constants/constants";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import type { ApiWave } from "@/generated/models/ApiWave";
import { formatStatFloor, getProfileTargetRoute } from "@/helpers/Helpers";
import { getActiveWaveIdFromUrl, getWaveHomeRoute, getWaveRoute } from "@/helpers/navigation.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef, type ComponentType } from "react";
import { useHoverDirty } from "react-use";
import HeaderSearchModalItemMedia from "./HeaderSearchModalItemMedia";
import HeaderSearchModalPfp from "./HeaderSearchModalPfp";
export interface NFTSearchResult {
  id: number;
  name: string;
  contract: string;
  icon_url: string;
  thumbnail_url: string;
  image_url: string;
}
export interface PageSearchResult {
  type: "PAGE";
  title: string;
  href: string;
  breadcrumbs: string[];
  icon?: ComponentType<{
    className?: string | undefined;
  }> | undefined;
}
export type HeaderSearchModalItemType = CommunityMemberMinimal | NFTSearchResult | ApiWave | PageSearchResult;
export const getNftCollectionMap = () => {
  return {
    [MEMES_CONTRACT.toLowerCase()]: {
      title: "The Memes",
      path: "/the-memes"
    },
    [MEMELAB_CONTRACT.toLowerCase()]: {
      title: "Meme Lab",
      path: "/meme-lab"
    },
    [GRADIENT_CONTRACT.toLowerCase()]: {
      title: "6529 Gradient",
      path: "/6529-gradient"
    },
    [NEXTGEN_CORE[NEXTGEN_CHAIN_ID].toLowerCase()]: {
      title: "NextGen",
      path: "/nextgen/token"
    }
  };
};
export default function HeaderSearchModalItem(t0) {
  const $ = _c(82);
  const {
    content,
    isSelected,
    onHover,
    onClose
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const ref = useRef(null);
  const isHovering = useHoverDirty(ref as React.RefObject<HTMLDivElement>);
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(hover: hover)").matches;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const supportsHover = t1;
  let t2;
  if ($[1] !== content) {
    t2 = () => (content as PageSearchResult).type === "PAGE";
    $[1] = content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isPage = t2;
  let t3;
  if ($[3] !== content) {
    t3 = () => Object.hasOwn(content, "handle");
    $[3] = content;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isProfile = t3;
  let t4;
  if ($[5] !== content) {
    t4 = () => Object.hasOwn(content, "contract");
    $[5] = content;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const isNft = t4;
  let t5;
  if ($[7] !== content) {
    t5 = () => content as ApiWave;
    $[7] = content;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const getWave = t5;
  let t6;
  if ($[9] !== content) {
    t6 = () => content as CommunityMemberMinimal;
    $[9] = content;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const getProfile = t6;
  let t7;
  if ($[11] !== content) {
    t7 = () => content as NFTSearchResult;
    $[11] = content;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const getNft = t7;
  let t8;
  if ($[13] !== content) {
    t8 = () => content as PageSearchResult;
    $[13] = content;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const getPage = t8;
  const getMediaIcon = _temp;
  let t9;
  if ($[15] !== getNft || $[16] !== getPage || $[17] !== getProfile || $[18] !== getWave || $[19] !== isNft || $[20] !== isPage || $[21] !== isProfile) {
    t9 = () => {
      if (isProfile()) {
        const profile = getProfile();
        return <HeaderSearchModalPfp level={profile.level} src={profile.pfp} />;
      } else {
        if (isNft()) {
          const nft = getNft();
          return <HeaderSearchModalItemMedia nft={nft} />;
        } else {
          if (isPage()) {
            const page = getPage();
            const Icon_0 = page.icon ?? DocumentTextIcon;
            return getMediaIcon(Icon_0);
          } else {
            const wave = getWave();
            if (wave.picture) {
              return <HeaderSearchModalItemMedia src={wave.picture} alt={wave.name} roundedFull={true} />;
            }
            const isDm = wave.wave.admin_group.group?.is_direct_message;
            if (isDm) {
              return getMediaIcon(ChatBubbleIcon);
            }
            return getMediaIcon(WavesIcon);
          }
        }
      }
    };
    $[15] = getNft;
    $[16] = getPage;
    $[17] = getProfile;
    $[18] = getWave;
    $[19] = isNft;
    $[20] = isPage;
    $[21] = isProfile;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const getMedia = t9;
  let t10;
  if ($[23] !== isHovering || $[24] !== onHover) {
    t10 = () => {
      if (supportsHover) {
        onHover(isHovering);
      }
    };
    $[23] = isHovering;
    $[24] = onHover;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== isHovering) {
    t11 = [isHovering, supportsHover];
    $[26] = isHovering;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  useEffect(t10, t11);
  let t12;
  if ($[28] !== getNft || $[29] !== getPage || $[30] !== getProfile || $[31] !== getWave || $[32] !== isApp || $[33] !== isNft || $[34] !== isPage || $[35] !== isProfile || $[36] !== pathname || $[37] !== searchParams) {
    t12 = () => {
      if (isProfile()) {
        const profile_0 = getProfile();
        return getProfileTargetRoute({
          handleOrWallet: profile_0.handle ?? profile_0.wallet.toLowerCase(),
          pathname: pathname ?? "",
          defaultPath: USER_PAGE_TAB_IDS.IDENTITY
        });
      } else {
        if (isNft()) {
          const nft_0 = getNft();
          const collectionMap = getNftCollectionMap();
          const key = nft_0.contract.toLowerCase();
          return `${collectionMap[key]?.path}/${nft_0.id}`;
        } else {
          if (isPage()) {
            return getPage().href;
          } else {
            const wave_0 = getWave();
            const currentWaveId = getActiveWaveIdFromUrl({
              pathname,
              searchParams
            }) ?? undefined;
            const isDirectMessage = wave_0.chat?.scope?.group?.is_direct_message ?? false;
            if (currentWaveId === wave_0.id) {
              return getWaveHomeRoute({
                isDirectMessage,
                isApp
              });
            }
            return getWaveRoute({
              waveId: wave_0.id,
              isDirectMessage,
              isApp
            });
          }
        }
      }
    };
    $[28] = getNft;
    $[29] = getPage;
    $[30] = getProfile;
    $[31] = getWave;
    $[32] = isApp;
    $[33] = isNft;
    $[34] = isPage;
    $[35] = isProfile;
    $[36] = pathname;
    $[37] = searchParams;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  const getPath = t12;
  let t13;
  if ($[39] !== getNft || $[40] !== getPage || $[41] !== getProfile || $[42] !== getWave || $[43] !== isNft || $[44] !== isPage || $[45] !== isProfile) {
    t13 = () => {
      if (isProfile()) {
        return getProfile().handle ?? "-";
      } else {
        if (isNft()) {
          return getNft().name;
        } else {
          if (isPage()) {
            return getPage().title;
          } else {
            return getWave().name;
          }
        }
      }
    };
    $[39] = getNft;
    $[40] = getPage;
    $[41] = getProfile;
    $[42] = getWave;
    $[43] = isNft;
    $[44] = isPage;
    $[45] = isProfile;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  const getPrimaryText = t13;
  let t14;
  if ($[47] !== getNft || $[48] !== getPage || $[49] !== getProfile || $[50] !== getWave || $[51] !== isNft || $[52] !== isPage || $[53] !== isProfile) {
    t14 = () => {
      if (isProfile()) {
        const profile_1 = getProfile();
        return `TDH: ${formatStatFloor(profile_1.tdh)} - Level: ${profile_1.level}`;
      } else {
        if (isNft()) {
          const nft_1 = getNft();
          const collectionMap_0 = getNftCollectionMap();
          const key_0 = nft_1.contract.toLowerCase();
          return `${collectionMap_0[key_0]?.title} #${nft_1.id}`;
        } else {
          if (isPage()) {
            const page_0 = getPage();
            if (page_0.breadcrumbs.length > 0) {
              return page_0.breadcrumbs.join(" \u2022 ");
            }
            return page_0.href;
          } else {
            const wave_1 = getWave();
            return `Wave #${wave_1.serial_no}`;
          }
        }
      }
    };
    $[47] = getNft;
    $[48] = getPage;
    $[49] = getProfile;
    $[50] = getWave;
    $[51] = isNft;
    $[52] = isPage;
    $[53] = isProfile;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  const getSecondaryText = t14;
  let t15;
  if ($[55] !== getPrimaryText) {
    t15 = getPrimaryText();
    $[55] = getPrimaryText;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  const primaryText = t15;
  let t16;
  if ($[57] !== getSecondaryText) {
    t16 = getSecondaryText();
    $[57] = getSecondaryText;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  const secondaryText = t16;
  const t17 = `${isSelected ? "tw-bg-iron-800" : ""} tw-my-1 tw-w-full tw-rounded-lg tw-px-2 tw-py-2 tw-transition tw-duration-300 tw-ease-out`;
  let t18;
  if ($[59] !== getPath) {
    t18 = getPath();
    $[59] = getPath;
    $[60] = t18;
  } else {
    t18 = $[60];
  }
  let t19;
  if ($[61] !== getMedia) {
    t19 = getMedia();
    $[61] = getMedia;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  let t20;
  if ($[63] !== primaryText) {
    t20 = <span className="tw-block tw-min-w-0 tw-truncate">{primaryText}</span>;
    $[63] = primaryText;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  let t21;
  if ($[65] !== primaryText || $[66] !== t20) {
    t21 = <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-3"><span className="tw-min-w-0 tw-flex-1 tw-text-sm tw-font-semibold tw-text-white" title={primaryText}>{t20}</span></div>;
    $[65] = primaryText;
    $[66] = t20;
    $[67] = t21;
  } else {
    t21 = $[67];
  }
  const t22 = secondaryText || undefined;
  let t23;
  if ($[68] !== secondaryText || $[69] !== t22) {
    t23 = <p className="tw-mb-0 tw-min-w-0 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-sm tw-text-iron-400" title={t22}>{secondaryText}</p>;
    $[68] = secondaryText;
    $[69] = t22;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== t21 || $[72] !== t23) {
    t24 = <div className="tw-min-w-0 tw-flex-1">{t21}{t23}</div>;
    $[71] = t21;
    $[72] = t23;
    $[73] = t24;
  } else {
    t24 = $[73];
  }
  let t25;
  if ($[74] !== onClose || $[75] !== t18 || $[76] !== t19 || $[77] !== t24) {
    t25 = <Link href={t18} onClick={onClose} className="tw-group tw-flex tw-w-full tw-min-w-0 tw-select-none tw-items-center tw-gap-3 tw-text-left tw-text-sm tw-font-medium tw-no-underline">{t19}{t24}</Link>;
    $[74] = onClose;
    $[75] = t18;
    $[76] = t19;
    $[77] = t24;
    $[78] = t25;
  } else {
    t25 = $[78];
  }
  let t26;
  if ($[79] !== t17 || $[80] !== t25) {
    t26 = <div ref={ref} className={t17}>{t25}</div>;
    $[79] = t17;
    $[80] = t25;
    $[81] = t26;
  } else {
    t26 = $[81];
  }
  return t26;
}
function _temp(Icon) {
  return <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-900"><Icon className="tw-h-5 tw-w-5" /></div>;
}